import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat, textLabels } from '../../../../helpers';
import { convertirVEF } from '../../../../helpers/ConversionesHelper';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allRecibosAction,
  deleteRecibosAction,
  setActivoRecibosAction,
  updateEstatusRecibosAction,
} from '../RecibosAction';
import { PARAMS_RECIBOS } from '../RecibosReducer';
import DetallesRecibosComponent from './DetallesRecibos';
import ExpandedRecibosComponent from './ExpandedRecibos';
import FormUpdateEstatusRecibos from './FormUpdateEstatusRecibos';
import SelectEstatusRecibosComponent from './SelectEstatusRecibos';

let intervalSearch = null;

const ListadoRecibos = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);
  const recibosStore = Redux.useSelector((state) => state.recibos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [openModalDetalles, setOpenModalDetalles] = React.useState(false);
  const [selectEstatus, setSelectEstatus] = React.useState(null);
  const [rows, setRows] = React.useState([]);

  const [openModalUpdateEstatus, setOpenModalUpdateEstatus] =
    React.useState(false);

  const [loadingUpdateEstatus, setLoadingUpdateEstatus] = React.useState(false);

  async function all(payload) {
    await allRecibosAction(dispatch, payload);
  }

  React.useEffect(() => {
    const payload = {
      ...recibosStore.params,
      idEntidad: entidadesStore.activo.id,
    };
    dispatch({ type: PARAMS_RECIBOS, payload });
    if (recibosStore.all && recibosStore.all.length === 0) {
      all(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let dataRows = [];
    recibosStore.all.forEach((el) => {
      dataRows.push({
        ...el,
        image: el.imgfoto,
        fecha: {
          tope: dateformat(el.fechaTope, { inverse: true }),
          pago: el.fechaPago
            ? dateformat(el.fechaPago, { inverse: true })
            : '--',
          verificado: el.fechaVerificado
            ? dateformat(el.fechaVerificado, { inverse: true })
            : '--',
          estatus: el.fechaEstatus
            ? dateformat(el.fechaEstatus, { inverse: true })
            : '--',
        },
        foto: el.matricula.estudiante.usuario.perfil.avatar,
        dni: el.matricula.estudiante.usuario.perfil.dni,
        nombre: {
          familiar: `${el.familiar?.perfil?.tipoDni}-${el.familiar?.perfil?.dni} ${el.familiar?.perfil?.pnombre} ${el.familiar?.perfil?.papellido}`,
          nombre: `${el.matricula.estudiante.usuario.perfil.tipoDni}-${
            el.matricula.estudiante.usuario.perfil.dni
          } ${el.matricula.estudiante.usuario.perfil.pnombre} ${
            el.matricula.estudiante.usuario.perfil.snombre
              ? el.matricula.estudiante.usuario.perfil.snombre
              : ''
          } ${el.matricula.estudiante.usuario.perfil.papellido} ${
            el.matricula.estudiante.usuario.perfil.sapellido
              ? el.matricula.estudiante.usuario.perfil.sapellido
              : ''
          }`,
          nivelAcademico:
            el.matricula.secciones[0].seccion.nivelAcademico.nombre,
          seccion: el.matricula.secciones[0].seccion.nombre,
          turno: el.matricula.secciones[0].seccion.turno,
        },
      });
    });
    setRows(dataRows);
  }, [recibosStore.all]);

  function getDataStore(id) {
    return recibosStore.all.find((el) => el.id === id);
  }

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteRecibosAction(
      { dispatch, notify },
      recibosStore.activo.id,
      recibosStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.codigo.name,
      label: CONST.codigo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>
              {value}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.foto.name,
      label: CONST.foto.label,
      width: '10%',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value}
              sx={{ width: 30, height: 30 }}
              src={getFilesArchivos(value)}
            />
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="column">
              <NameComponent>{value.familiar}</NameComponent>
              <Typography sx={{ fontSize: '10pt' }}>{value.nombre}</Typography>
              <Stack direction="row" spacing={1}>
                <Typography variant="caption">
                  <strong>Nivel acadêmico: </strong>
                  {value.nivelAcademico}
                </Typography>
                <Typography variant="caption">
                  <strong>Sección: </strong>
                  {value.seccion}
                </Typography>
                {/* <Typography variant="caption">
                  <strong>Turno: </strong>
                  {value.turno}
                </Typography> */}
              </Stack>
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.total.name,
      label: 'Montos',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const cambios = {};
          entMonedasStore.all.forEach((item) => {
            if (item.cambio) {
              let total = 0.0;
              if (item.cambio.abrev === 'VEF') {
                total = convertirVEF(item.tasa, value);
              }
              cambios[item.cambio.abrev] = total;
            }
          });
          return (
            <Box>
              <Typography sx={{ fontSize: 16 }}>$ {value} USD</Typography>
              {entMonedasStore.all.map((el, index) => {
                return (
                  el.cambio && (
                    <Typography key={`cambio-${index}`} sx={{ fontSize: 16 }}>
                      {el.cambio.simbolo} {cambios[el.cambio.abrev]}{' '}
                      {el.cambio.abrev}
                    </Typography>
                  )
                );
              })}
            </Box>
          );
        },
      },
    },
    {
      name: CONST.fecha.name,
      label: 'Fechas',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box>
              Tope: {value.tope} <br />
              Pago: {value.pago} <br />
              Verificado: {value.verificado} <br />
              Estatus: {value.estatus} <br />
            </Box>
          );
        },
      },
    },

    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <SelectEstatusRecibosComponent
            value={value.id}
            isAll={false}
            ignoreIds={[
              value.id === 3 ? null : 3,
              value.id === 7 ? null : 7,
              9,
              10,
            ]}
            onChange={async (idEstatus) => {
              if (idEstatus !== 8) {
                setSelectEstatus(idEstatus);
                setActivoRecibosAction(
                  dispatch,
                  getDataStore(tableMeta.rowData[0]),
                );
                setOpenModalUpdateEstatus(true);
                return;
              }

              setLoadingUpdateEstatus(true);
              await updateEstatusRecibosAction(
                {
                  dispatch,
                  notify,
                },
                tableMeta.rowData[0],
                {
                  fecha: dayjs(),
                  idEstatus,
                },
                recibosStore.params,
              );
              setLoadingUpdateEstatus(false);
            }}
          />
        ),
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onDelete={() => {
                  setActivoRecibosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDelete(true);
                }}
                onDetalles={() => {
                  setActivoRecibosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDetalles(true);
                }}
                onEstatus={() => {
                  setActivoRecibosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalUpdateEstatus(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: recibosStore.params.limit,
    count: recibosStore.pagination.totalItems,
    page: recibosStore.pagination.currentPage - 1,
    rowsPerPageOptions: [50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = getDataStore(rowData[0]);
      return <ExpandedRecibosComponent data={data} rowData={rowData} />;
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...recibosStore.params,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_RECIBOS, payload });
          all(payload);
        }, 800);
      }
    },
    onSearchClose: () => {
      const payload = {
        ...recibosStore.params,
        q: null,
      };
      dispatch({ type: PARAMS_RECIBOS, payload });
      all(payload);
    },
    onChangePage: async (currentPage) => {
      const payload = {
        ...recibosStore.params,
        page: currentPage + 1,
      };
      dispatch({
        type: PARAMS_RECIBOS,
        payload,
      });
      all(payload);
    },
    onChangeRowsPerPage: async (numberOfRows) => {
      const payload = {
        ...recibosStore.params,
        limit: numberOfRows,
      };
      dispatch({
        type: PARAMS_RECIBOS,
        payload,
      });
      all(payload);
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={
            recibosStore.loadingAll || loadingDelete || loadingUpdateEstatus
          }
        />
        <MUIDataTable
          title={`Listado de (${recibosStore.all.length}) registros`}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {recibosStore.activo && (
        <>
          <ModalComponent
            id="modalFormRecibo"
            title={`Detalle del recibo: ${recibosStore.activo.codigo}`}
            maxWidth={openModalUpdateEstatus ? 'sm' : 'lg'}
            open={openModalDetalles || openModalUpdateEstatus}
            onClose={() =>
              openModalUpdateEstatus
                ? setOpenModalUpdateEstatus(!openModalUpdateEstatus)
                : setOpenModalDetalles(!openModalDetalles)
            }
          >
            {openModalUpdateEstatus && (
              <FormUpdateEstatusRecibos
                setOpenModalForm={(val) => setOpenModalUpdateEstatus(val)}
                selectEstatus={selectEstatus}
              />
            )}
            {openModalDetalles && <DetallesRecibosComponent />}
          </ModalComponent>
          <DeleteModalComponent
            open={openModalDelete}
            onClose={() => setOpenModalDelete(!openModalDelete)}
            onDelete={_onDeleteHandler}
          >
            {detallesInfoRecibo(recibosStore.activo)}
          </DeleteModalComponent>
        </>
      )}
    </Grid>
  );
};

export default ListadoRecibos;

export const detallesInfoRecibo = (data) => {
  return (
    <>
      <Typography>
        <strong>Conceptos:</strong> {data.conceptosPago.length}
      </Typography>
      <Typography>
        <strong>Monto:</strong> {data.total}
      </Typography>
      <Typography>
        <strong>Fecha tope:</strong>{' '}
        {dateformat(data.fecha, {
          inverse: true,
        })}
      </Typography>
      <Typography>
        <strong>Representante:</strong>{' '}
        {`
          ${data.familiar?.perfil.tipoDni}-${data.familiar?.perfil.dni}
          ${data.familiar?.perfil.pnombre} 
          ${
            data.familiar?.perfil.snombre ? data.familiar?.perfil.snombre : ''
          } ${data.familiar?.perfil.papellido} ${
            data.familiar?.perfil.sapellido
              ? data.familiar?.perfil.sapellido
              : ''
          }`}
      </Typography>

      <Typography>
        <strong>Estudiante:</strong>{' '}
        {`
                ${data.matricula.estudiante.usuario.perfil.tipoDni}-${
                  data.matricula.estudiante.usuario.perfil.dni
                }
                ${data.matricula.estudiante.usuario.perfil.pnombre} 
                ${
                  data.matricula.estudiante.usuario.perfil.snombre
                    ? data.matricula.estudiante.usuario.perfil.snombre
                    : ''
                } ${data.matricula.estudiante.usuario.perfil.papellido} ${
                  data.matricula.estudiante.usuario.perfil.sapellido
                    ? data.matricula.estudiante.usuario.perfil.sapellido
                    : ''
                }`}
      </Typography>
    </>
  );
};
